module.exports = __webpack_public_path__ + "5d17a454e02e6197f124282e9a24fb5b.MP3";